import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Components/CSS/BlogCard.module.css';
import { useBlogs } from '../hooks/useBlogs';
import useBlogStore from '../store/blogsStore';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const BlogCard = () => {
  const navigate = useNavigate();
  const { blogs, isLoading, error, refetchBlogs } = useBlogs();
  const { visibleCards, incrementVisibleCards } = useBlogStore();

  // Add this useEffect to handle initial data fetching
  useEffect(() => {
    refetchBlogs();
  }, [refetchBlogs]);

  const stripHtmlTags = (html) => {
    return (html || '').replace(/<[^>]*>/g, '');
  };


 if (isLoading) {
  return (
    <SkeletonTheme baseColor="#2a2a2a" highlightColor="#3a3a3a">
      <div className={styles.cardGrid}>
        {Array.from({ length: visibleCards }).map((_, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.imageContainer}>
              <Skeleton height={200} />
            </div>
            <div className={styles.content}>
              <Skeleton height={20} style={{ marginBottom: '8px' }} />
              <Skeleton count={3} height={14} />
            </div>
          </div>
        ))}
      </div>
    </SkeletonTheme>
  );
}

  if (error) {
    return <div className={styles.error}>Error loading blogs</div>;
  }

  if (!blogs?.blogs || blogs.blogs.length === 0) {
    return (
      <div className={styles.noBlogsContainer}>
        <p className={styles.noBlogs}>No blogs available at the moment</p>
      </div>
    );
  }

  const blogPosts = blogs.blogs;

  return (
    <>
      <div className={styles.cardGrid}>
        {blogPosts.slice(0, visibleCards).map((blog) => {
          const plainTextContent = stripHtmlTags(blog.content);
          const preview = plainTextContent
            .split(/\s+/)
            .slice(0, 15)
            .join(" ") + "...";

          return (
            <div key={blog.id} className={styles.card} onClick={() => navigate(`/blog/${blog.slug}`)} >
              <div className={styles.imageContainer}>
                {blog.coverImage ? (
                  <img 
                    src={blog.coverImage} 
                    alt={blog.title} 
                    className={styles.image}
                  />
                ) : (
                 <img 
                    src={blog.featuredImage} 
                    alt={blog.title} 
                    className={styles.image}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>

      {blogPosts.length > visibleCards && (
        <div className={styles.loadMoreContainer}>
          <button onClick={() => incrementVisibleCards()} className={styles.loadMoreButton}>
            Load More
          </button>
        </div>
      )}
    </>
  );
};

export default BlogCard;